<template>
  <div>
    <div class="page-title">
      <v-icon style="color: rgb(48, 72, 123); margin-right: 15px" size="20" dark
        >far fa-sticky-note</v-icon
      >關於我們
    </div>
    <div id="container" class="con_text">
      <div id="con_1">
        <div id="about-main-title">賽馬會社區長者急救學堂</div>
        <div id="about-sub-title">
          Jockey Club Community Programme on Elderly Emergency Care
        </div>

        <div id="con_1_con">
          賽馬會社區長者急救學堂將推行一項針對長者緊急護理及由長者提供服務的特定計劃。此項目由香港賽馬會慈善信託基金捐助，採用樂齡教育的原則，為長者提供緊急護理培訓，藉此幫助他們成為同輩的指導員或服務提供者。我們希望此計劃能成為長者緊急護理教育的雛型，在供其他提供長者服務的組織用作參考的同時，進一步成為社會資本，讓社會更多長者受惠。
        </div>

        <div id="by">
          <div id="organised">
            <div>主辦機構 Organised by</div>
            <img id="organised_img" src="../assets/hkumed_logo.png" />
          </div>
          <div id="funded">
            <div>捐助機構 Funded by</div>
            <img id="funded_img" src="../assets/hkjc_logo.png" />
          </div>
        </div>
      </div>

      <div id="con_2">
        <img id="con_2_img" src="../assets/Image_04.png" width="45%" />
        <div id="con_2_title">人類老化是自然的階段。</div>
        <div id="con_2_con">
          人類老化是自然的階段。我們大多數都會經歷正常的衰老，身體的改變不一定有害，而只是像徵生物功能的減慢。但是有許多不正常的症狀可由疾病引起的，不過這些症狀是可以預防和治療的。長者容易感染傳染病、慢性病、創傷和其他急性疾病。儘管在過去的二十年間，香港政府促進基層醫療作出努力，但香港的長者依然高度依賴醫院服務。每年因急性疾病或受傷的長者在急診室住院或接受治療有成千上萬。
        </div>
      </div>

      <div id="con_3">
        <div id="con_3_banner">
          <img id="con_3_banner_img_img" src="../assets/Image_03.png" />
          <div id="con_3_banner_img"></div>
          <div id="con_3_banner_title">
            隨著人口的老齡化，對這些服務的需求使公共衛生系統不堪重負。
          </div>
        </div>
        <div id="con_3_con">
          <p id="con_3_con_1">
            例如，根據2005-2006年公共醫院服務的使用率，估計65歲或65歲以上的人的平均住院天數比65歲以下的人多出6倍。所以，提高知識和技能的普及率為出者進行緊急護理是一個確切可行的解決方案。值得關注的是，長者的三大「殺手」為：心臟病（尤其是冠狀動脈疾病（冠心病）引起的心臟病發），腦血管疾病（尤其是中風）和跌倒。心臟病是香港第三大死亡原因之一，其中近70％是由冠狀動脈疾病而引起的。
          </p>
          <p style="padding-top: 15px" id="con_3_con_2">
            長者年邁65歲時，接近十分之一的人患有心臟病。2015年統計，在醫院管理局轄下醫院因冠心病而住院的病人超過7,000人。腦血管疾病在香港也是引起死亡的主要原因，位居第四。平均而言，全世界每6秒鐘有人死於中風。在香港，每年有3,000多人喪生。隨之而來的殘疾也是受影響者，成為他們的家庭和社區的主要負擔。另外，長者跌倒亦十分是常見的。於6
            5歲以上的成年人組別中，每年約有30％的長者至少跌倒一次，而經常跌倒的人則為15％。長者跌倒可能會造成嚴重後果，甚至因為嚴重創傷而死亡。據報在香港，12個月內跌倒的長者百分比約為19％。結果其中有近7％受到重傷。
          </p>
        </div>
      </div>
      <div id="con_4">
        <div id="con_4_banner">
          <div id="con_4_banner_title">
            本項目中的「緊急護理」比「急救」具有更廣泛的含義。
          </div>
          <img id="con_4_banner_img_img" src="../assets/Image_01.png" />
          <div id="con_4_banner_img"></div>
        </div>
        <div id="con_4_con">
          <p id="con_4_con_1">
            後者是指患有急性疾病或受傷的人的緊急護理。緊急護理指為保護生命，預防惡化和促進康復而遭受疾病或傷害的任何人提供的援助。除了急救人員採取的急性護理（即急救）外，它還涵蓋了減輕急性疾病和傷害的風險，並為發生急性疾病和傷害的發生做準備的知識和技能。適當的緊急救護不僅可以生死攸關，還可以幫助確定緊急情況下採取行動和治療的順序和優先順序，從而可以實現最佳結果。
          </p>
          <p style="padding-top: 15px" id="con_4_con_2">
            為了實現最佳結果，緩解和備災的概念尤為重要。例如，將跌倒的風險降至最低，可以避免長期摔倒和遭受跌倒的老人的生活質量下降。另一個例子，使中風發生的風險降低，以避免中風後的毀滅性殘疾。同樣，準備充分的個人也可以更迅速，更有效地應對緊急情況。緊急護理知識和技能還可以促進日常生活中的安全和健康意識。
          </p>
        </div>
      </div>

      <div id="con_5">
        <div id="con_5_banner">
          <img id="con_5_banner_img_img" src="../assets/Image_02.png" />
          <div id="con_5_banner_img"></div>
          <div id="con_5_banner_title">
            受過訓練的人更有能力區分什麼可做和不可做，並選擇合適的服務。
          </div>
        </div>
        <div id="con_5_con">
          <p id="con_5_con_1">
            因此，緊急護理的培訓可以幫助受訓人員及有需要的人。這些好處對於容易遭受各種急性疾病和傷害的老年人尤為明顯。但是，將近7
            0％的當地人口從未接受過此類培訓。這個比例在老年人口中可能更高。更糟糕的是，這個問題尚未引起醫療保健專業人員的足夠重視。香港並沒有專門針對此需求的培訓課程或計劃。大多數緊急護理課程都是急救課程的形式，這些課程是長期的，沒有針對性的，並且僅針對任何年齡的成年人。培訓材料，方法和步調可能不適用於老年學習者。
          </p>
          <p style="padding-top: 15px" id="con_5_con_2">
            此外，在大多數課程中講授的某些知識和實踐技能可能不是老年人最常遇到的緊急醫療情況。社區中有一些針對老年人的“急救大使”計劃。在這些計劃中受過培訓的老人的主要作用是提高急救對其他老人的重要性。他們在現實生活中提供緊急護理的能力令人懷疑。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      aboutUsArray: [],

      baseUrl: "",
    };
  },
  methods: {
    getBaseUri() {
      this.axios
        .get("/api/api.php?p=data/baseUrl")
        .then((response) => {
          this.baseUrl = response.data.sdata["url"];
          // console.log(this.baseUrl);
        })
        .catch(function (error) {
          // 请求失败处理
          console.log(error);
        });
    },
    async getarticleData() {
      this.articleArray = [];
      //about us data get
      await this.axios({
        method: "get",
        url: "/api/api.php?p=data/aboutUs",
      })
        .then((response) => {
          // console.log(response);

          var mainTitle = document.getElementById("about-main-title");
          var mainContent = document.getElementById("about-sub-title");
          var con1 = document.getElementById("con_1_con");
          var organised_img = document.getElementById("organised_img");
          var funded_img = document.getElementById("funded_img");

          var con2i = document.getElementById("con_2_img");
          var con2t = document.getElementById("con_2_title");
          var con2c = document.getElementById("con_2_con");

          var con3i = document.getElementById("con_3_banner_img_img");
          var con3t = document.getElementById("con_3_banner_title");
          var con3c_1 = document.getElementById("con_3_con_1");
          var con3c_2 = document.getElementById("con_3_con_2");

          var con4i = document.getElementById("con_4_banner_img_img");
          var con4t = document.getElementById("con_4_banner_title");
          var con4c_1 = document.getElementById("con_4_con_1");
          var con4c_2 = document.getElementById("con_4_con_2");

          var con5i = document.getElementById("con_5_banner_img_img");
          var con5t = document.getElementById("con_5_banner_title");
          var con5c_1 = document.getElementById("con_5_con_1");
          var con5c_2 = document.getElementById("con_5_con_2");

          mainTitle.innerHTML = response.data["sdata"].data[0]["value"];
          mainContent.innerHTML = response.data["sdata"].data[1]["value"];
          con1.innerHTML = response.data["sdata"].data[2]["value"];
          organised_img.src =
            this.baseUrl + "image_upload/" + response.data["sdata"].data[3]["img"];
          funded_img.src =
            this.baseUrl + "image_upload/" + response.data["sdata"].data[4]["img"];

          con2i.src =
            this.baseUrl + "image_upload/" + response.data["sdata"].data[5]["img"];
          con2t.innerHTML = response.data["sdata"].data[6]["value"];
          con2c.innerHTML = response.data["sdata"].data[7]["value"];

          con3i.src =
            this.baseUrl + "image_upload/" + response.data["sdata"].data[8]["img"];
          con3t.innerHTML = response.data["sdata"].data[9]["value"];
          con3c_1.innerHTML = response.data["sdata"].data[10]["value"];
          con3c_2.innerHTML = response.data["sdata"].data[11]["value"];

          con4i.src =
            this.baseUrl + "image_upload/" + response.data["sdata"].data[12]["img"];
          con4t.innerHTML = response.data["sdata"].data[13]["value"];
          con4c_1.innerHTML = response.data["sdata"].data[14]["value"];
          con4c_2.innerHTML = response.data["sdata"].data[15]["value"];

          con5i.src =
            this.baseUrl + "image_upload/" + response.data["sdata"].data[16]["img"];
          con5t.innerHTML = response.data["sdata"].data[17]["value"];
          con5c_1.innerHTML = response.data["sdata"].data[18]["value"];
          con5c_2.innerHTML = response.data["sdata"].data[19]["value"];
        })
        .catch(function (error) {
          // 请求失败处理
          console.log(error);
        });
      //about ua data post
    },
  },
  mounted() {
    this.getBaseUri();
    this.getarticleData();
  },
};
</script>

<style scoped>
#con_5_con {
  padding: 55px 22% 55px 22%;
  font-size: 23px;
  text-align: left;
}
#con_5_banner_title {
  margin-right: 15%;
  color: rgb(52, 72, 130);
  font-size: 40px;
  font-weight: bold;
  text-align: left;
  line-height: 55px;
  align-items: center;
  margin-top: auto;
  margin-bottom: auto;
}
#con_5_banner_img {
  margin-left: 13%;
  margin-right: 10%;
  padding-left: 350px;
  height: 300px;
}
#con_5_banner img {
  position: absolute;
  margin-left: 15%;
  width: 380px;
  height: 420px;
  margin-top: -60px;
}
#con_5_banner {
  position: relative;
  display: flex;
  background-color: rgb(228, 244, 255);
  margin-top: 60px;
  margin-bottom: 60px;
}
#con_4_con {
  padding: 45px 22% 55px 22%;
  font-size: 23px;
  text-align: left;
}
#con_4_banner_title {
  margin-left: 13%;
  color: rgb(52, 72, 130);
  font-size: 40px;
  font-weight: bold;
  text-align: left;
  line-height: 55px;
  align-items: center;
  margin-top: auto;
  margin-bottom: auto;
}
#con_4_banner_img {
  margin-left: 13%;
  margin-right: 10%;
  padding-left: 350px;
  height: 330px;
}
#con_4_banner img {
  position: absolute;
  margin-left: 63%;
  width: 550px;
  height: 430px;
  margin-top: -60px;
}
#con_4_banner {
  position: relative;
  display: flex;
  background-color: rgb(255, 244, 233);
  margin-top: 60px;
  margin-bottom: 60px;
}
#con_3_con {
  padding: 55px 22% 55px 22%;
  font-size: 23px;
  text-align: left;
}
#con_3_banner_title {
  margin-right: 15%;
  color: rgb(52, 72, 130);
  font-size: 40px;
  font-weight: bold;
  text-align: left;
  line-height: 55px;
  align-items: center;
  margin-top: auto;
  margin-bottom: auto;
}
#con_3_banner_img {
  margin-left: 13%;
  margin-right: 10%;
  padding-left: 350px;
  height: 300px;
}
#con_3_banner img {
  /* flex:1; */
  position: absolute;
  margin-left: 12%;
  width: 420px;
  height: 390px;
  margin-top: -30px;
}
#con_3_banner {
  position: relative;
  display: flex;
  background-color: rgb(228, 244, 255);
  margin-top: 60px;
  margin-bottom: 60px;
}
#con_2_con {
  font-size: 23px;
  padding: 15px 22% 30px 22%;
}

#con_2_title {
  color: rgb(52, 72, 130);
  font-size: 40px;
  font-weight: bold;
}
#con_2 {
  margin-top: 50px;
  text-align: center;
}

#organised {
  font-size: 25px;
  text-align: center;
  margin-right: 50px;
}
#funded {
  font-size: 25px;
  text-align: center;
}
#by {
  justify-content: center;
  padding: 20px 15% 40px 15%;
  display: flex;
}
#con_1_con {
  padding: 25px 20% 25px 20%;
  font-size: 23px;
}
#con_1 {
  background-color: rgb(250, 250, 250);
}

.con_text {
  font-family: "mehk-m";
  text-align: center;
  color: rgb(92, 92, 92);
}

#about-main-title {
  text-align: center;
  font-family: "mehk-m";
  font-size: 50px;
  padding-top: 40px;
}
#about-sub-title {
  margin-top: -25px;
  text-align: center;
  font-family: "mehk-m";
  font-size: 18px;
}
.page-title {
  background-color: rgb(235, 246, 254);
  padding: 15px 50px 10px 70px;
  font-size: 25px;
  font-weight: bold;
}

@media only screen and (max-width: 1300px) {
  #con_4_banner img {
    margin-left: 55%;
  }
}

@media only screen and (max-width: 1060px) {
  #by {
    display: block;
  }
  #organised {
    margin: 0px;
  }
  #organised_img {
    width: 100%;
    height: 100%;
  }
  #funded_img {
    width: 100%;
    height: 100px;
  }
  #con_4_banner img {
    margin-left: 50%;
  }
}

@media only screen and (max-width: 900px) {
  #con_3_banner_title {
    margin-top: 5%;

    margin-left: 3%;
    margin-right: 8%;
    margin-bottom: 5%;
    font-size: 35px;
  }

  #con_4_banner_title {
    margin-left: 8%;
    font-size: 35px;
  }

  #con_4_banner img {
    width: 450px;
    height: 380px;
    margin-left: 50%;
    margin-top: -20px;
  }
  #con_4_banner_img {
    padding-left: 270px;
  }

  #con_3_banner_img {
    height: auto;
    margin-right: 0px;
  }

  #con_3_banner img {
    width: 40%;
    height: auto;
    top: 10%;
    margin-left: 8%;
  }


  #con_5_banner_title{
    margin-right: 8%;
  }

  #con_5_banner_img{
    margin-left: 8%;

  }

  #con_5_banner img{
    width:300px;
    height:340px;
  }
}

@media only screen and (max-width: 690px) {
  #con_3_banner img {
    top: 30%;
  }
  #con_3_banner_img {
    margin-left: 8%;
    padding-left: 350px;
  }
  #con_4_banner img {
    width: 350px;
    height: 290px;
    margin-left: 45%;
    margin-top: 10px;
  }
  #con_4_banner_img {
    margin-left: 10%;
    margin-right: 8%;
  }

  #con_5_banner_img{
    margin-left: 8%;
    padding-left: 200px;
  }

  #con_5_banner img{
    
    margin-top: 5%;
    width:200px;
    height:240px;
  }
}

@media only screen and (max-width: 650px) {
  #about-main-title {
    font-size: 40px;
  }

  #con_1_con {
    padding: 25px 10% 25px 10%;
  }
  #con_2_con {
    padding: 15px 10% 30px 10%;
  }

  #con_3_con {
    padding: 20px 10% 20px 10%;
  }

  #con_4_con {
    padding: 20px 10% 20px 10%;
  }

  #con_5_con {
    padding: 20px 10% 20px 10%;
  }
}

@media only screen and (max-width: 600px) {
  #con_3_banner_img {
    margin-left: 8%;
    padding-left: 250px;
  }
  #con_3_banner_title {
    font-size: 30px;
  }

  #con_4_banner_title {
    font-size: 30px;
    line-height: 50px;
  }

  #con_4_banner img {
    margin-top:10%;
    margin-left: 50%;
    width: 260px;
    height: 220px;
  }
  #con_5_banner_img {
        margin-left: 4%;
    padding-left: 180px;
  }

  #con_5_banner img {
    margin-top:10%;
    width: 150px;
    height: 190px;
  }
  #con_4_banner_img {
    margin-left: 10%;
    margin-right: 8%;
    padding-left: 190px;
  }

  #con_5_banner_title{
    font-size:30px;
    line-height: 40px;
  }
}
</style>
